import { Button, Card, EmptyState, NoticeBox } from "../ui";
import ApplicationFiles from "./ApplicationFiles";
import { APP_KEYS, APP_LOGOS, appLabel, partsFor } from "./reportAnalysisModel";

// Step 2 - Applications & Files: which applications, and their files per report section. Nothing is
// checked here; "Next: Check Files" runs the server checks (step 3).
export default function FilesStep({ text, lang, state, plan, limits, disabled, notice, onToggleApp, onAdd, onReplace, onRemove, onDownload, onBack, onNext }) {
  const { context } = state;
  const canCheck = state.apps.length > 0 && state.partsLoaded && !disabled;
  return (
    <section className="report-analysis-step" data-testid="step-files" aria-label={text.flow.filesTitle}>
      <Card className="report-analysis-card" hoverable={false}>
        <header className="report-analysis-step__head">
          <h3>{text.flow.filesTitle}</h3>
          <p className="report-analysis-muted">{text.flow.filesHint}</p>
        </header>
        <fieldset className="report-analysis-apps" disabled={disabled}>
          <legend>{text.apps}</legend>
          <p className="report-analysis-muted">{text.appsHint}</p>
          <div className="report-analysis-apps__grid">
            {APP_KEYS.map((app) => {
              const selected = state.apps.includes(app);
              return (
                <button key={app} type="button" className={`report-analysis-app ${selected ? "is-selected" : ""}`} aria-pressed={selected} onClick={() => onToggleApp(app)}>
                  <img src={APP_LOGOS[app]} alt="" aria-hidden="true" />
                  <span>{appLabel(app, lang)}</span>
                </button>
              );
            })}
          </div>
        </fieldset>
      </Card>

      {notice && <NoticeBox variant="warning" size="sm"><span role="alert">{notice}</span></NoticeBox>}
      {!state.partsLoaded && <EmptyState variant="loading" compact>{text.loadingParts}</EmptyState>}

      {state.partsLoaded && state.apps.length > 0 && (
        <div className="report-analysis-grid report-analysis-grid--wide">
          {state.apps.map((app) => (
            <ApplicationFiles
              key={app}
              app={app}
              mode={context.mode}
              parts={partsFor(state.parts, { app, mode: context.mode, year: context.year, month: context.month })}
              uploads={state.uploads.filter((upload) => upload.app === app)}
              blockers={plan.blockers.filter((blocker) => blocker.app === app)}
              text={text}
              lang={lang}
              disabled={disabled}
              onAdd={(target, section, files) => onAdd(target, section, files, limits)}
              onReplace={onReplace}
              onRemove={onRemove}
              onDownload={onDownload}
            />
          ))}
        </div>
      )}

      {!state.apps.length && <p className="report-analysis-muted" role="note">{text.flow.chooseApps}</p>}

      <div className="report-analysis-actions">
        <Button appearance="soft" onClick={onBack} disabled={disabled}>{text.flow.backToSetup}</Button>
        <Button variant="primary" appearance="filled" onClick={onNext} disabled={!canCheck}>{text.flow.nextCheck}</Button>
      </div>
    </section>
  );
}
